import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MailCheck, Loader2 } from "lucide-react";
import { AgentStatus } from "@/components/email-agent/AgentStatus";
import { AgentKnowledge } from "@/components/email-agent/AgentKnowledge";
import { AgentFiles } from "@/components/email-agent/AgentFiles";
import { AgentLog } from "@/components/email-agent/AgentLog";

export default function EmailAgent() {
  const [cfg, setCfg] = useState(null);
  const [log, setLog] = useState([]);
  const load = useCallback(async () => {
    const [{ data: c }, { data: l }] = await Promise.all([api.get("/email-agent"), api.get("/email-agent/log")]);
    setCfg(c);
    setLog(l);
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (cfg?.training?.status !== "running") return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [cfg?.training?.status, load]);

  if (!cfg) return <div className="p-8 text-slate-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Φόρτωση…</div>;
  return (
    <div className="space-y-6 max-w-5xl" data-testid="email-agent-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 flex items-center gap-2"><MailCheck className="w-7 h-7 text-[#0052CC]" /> Email Agent</h1>
        <p className="mt-1 text-sm text-slate-600">Διαβάζει τα νέα email, ετοιμάζει απάντηση στο ύφος σας και την αφήνει στα «Πρόχειρα» του Outlook.</p>
      </div>
      <AgentStatus cfg={cfg} reload={load} />
      <Tabs defaultValue="log">
        <TabsList>
          <TabsTrigger value="log" data-testid="email-agent-tab-log">Δραστηριότητα</TabsTrigger>
          <TabsTrigger value="knowledge" data-testid="email-agent-tab-knowledge">Οδηγίες & Γνώσεις</TabsTrigger>
          <TabsTrigger value="files" data-testid="email-agent-tab-files">Αρχεία ({cfg.files.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="log"><AgentLog log={log} /></TabsContent>
        <TabsContent value="knowledge"><AgentKnowledge cfg={cfg} reload={load} /></TabsContent>
        <TabsContent value="files"><AgentFiles files={cfg.files} reload={load} /></TabsContent>
      </Tabs>
    </div>
  );
}
